import {closeModal} from '../../../redux/actions/ui/index.js'
import {hasPrintNodeAPIKeySelector} from '../../../data/company.js'
import {
  scalesSelector,
  hasPrintNodeScaleSelector,
  isReadingScaleSelector,
  readScale,
} from '../../../data/printNode.js'
import {dispatch, useSelector} from '../../../store.js'
import cn from '../../className.js'
import ButtonPrimary from '../Button/ButtonPrimary.js'
import {HK_READ_SCALE} from '../../constants/HotKeys.js'
import {SCALES, SETTINGS} from '../../constants/SettingsPanels.js'
import {navigate} from '../../location.js'
import Icon from '../../icons/Icon.js'

/**
 * The button to read the connect scale
 *
 * @param {Object} props
 * @param {String} [props.className]
 * @param {Function} props.onChange
 * @returns {React.ReactNode}
 */
export default function ScaleControl({className, onChange}) {
  const hasPrintNodeScale = useSelector(hasPrintNodeScaleSelector)
  const hasPrintNodeAPIKey = useSelector(hasPrintNodeAPIKeySelector)
  const hasScales = useSelector(scalesSelector).length !== 0
  const isReadingScale = useSelector(isReadingScaleSelector)

  if (!hasPrintNodeScale) {
    return null
  }

  if (!hasScales || !hasPrintNodeAPIKey) {
    return (
      <ButtonPrimary
        isOutlined
        size="xx-sm"
        className="margin-bottom-7 meta-usb-scale-setup flex align-items-center"
        onClick={() => {
          dispatch(closeModal())

          navigate([SETTINGS, SCALES])
        }}
        hotKey={HK_READ_SCALE}
      >
        <Icon name="scales" className="fs-00 lh-sm v-align-middle" />
        {!hasPrintNodeAPIKey && (
          <span className="fs-n3 btn__text--scale">SETUP</span>
        )}
        {hasPrintNodeAPIKey && !hasScales && (
          <span className="fs-n3 btn__text--scale">NO SCALE</span>
        )}
      </ButtonPrimary>
    )
  }

  return (
    <ButtonPrimary
      alt
      size="xx-sm"
      className={cn`margin-bottom-5 meta-usb-scale ${
        isReadingScale && 'btn--processing'
      } ${className}`}
      onClick={async (event) => {
        if (event) {
          event.preventDefault()
        }

        const selectedScaleWeight = await readScale()

        if (selectedScaleWeight !== null) {
          onChange(selectedScaleWeight)
        }
      }}
      disabled={isReadingScale}
      title={isReadingScale ? 'Reading weight...' : 'Read weight from scale'}
      hotKey={HK_READ_SCALE}
    >
      <Icon name="scales" className="fs-00 lh-sm v-align-middle" />
      <span className="fs-n3 btn__text--scale">WEIGH</span>
    </ButtonPrimary>
  )
}
